/* ==========================================================================
   Skinomakase x 4thdeath — auto-play intro
   A big centered logo holds, disintegrates into particles, and the particles
   reassemble as the small logo in the header. Plays once per page load.
   ========================================================================== */
(function () {
  "use strict";

  if (window.__skmkIntroHasRun) return;
  window.__skmkIntroHasRun = true;

  var body = document.body;

  var intro = document.querySelector("[data-skmk-intro]");
  var sourceImg = document.querySelector("[data-skmk-source-logo]");
  var canvas = document.querySelector("[data-skmk-canvas]");
  var targetLogo = document.querySelector("[data-skmk-target-logo]");

  var rafId = null;
  var safetyId = null;
  var finished = false;

  function finishToEndState() {
    if (finished) return;
    finished = true;
    if (rafId) cancelAnimationFrame(rafId);
    if (safetyId) clearTimeout(safetyId);
    if (sourceImg) sourceImg.style.visibility = "hidden";
    if (intro) intro.classList.add("is-finished");
    if (canvas) canvas.classList.add("is-finished");
    // if (targetLogo) targetLogo.classList.add("is-visible");
    body.classList.remove("skmk-intro-active");
  }

  // Nothing to animate — bail to the end state.
  if (!intro || !sourceImg || !canvas || !targetLogo) {
    finishToEndState();
    return;
  }

  var prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  var enabled = intro.getAttribute("data-enabled") !== "false";
  var DURATION = parseInt(intro.getAttribute("data-duration"), 10) || 3200;

  if (prefersReduced || !enabled) {
    finishToEndState();
    return;
  }

  body.classList.add("skmk-intro-active");
  // Real time fallback so a throttled background tab never traps the visitor.
  safetyId = setTimeout(finishToEndState, DURATION + 1200);

  imageReady(sourceImg).then(runIntro).catch(finishToEndState);

  /* ---------- helpers ---------- */

  function imageReady(img) {
    return new Promise(function (resolve, reject) {
      if (img.complete && img.naturalWidth > 0) {
        resolve();
        return;
      }
      var to = setTimeout(function () {
        img.naturalWidth > 0
          ? resolve()
          : reject(new Error("skmk: image timeout"));
      }, 1500);
      img.addEventListener(
        "load",
        function () {
          clearTimeout(to);
          resolve();
        },
        { once: true },
      );
      img.addEventListener(
        "error",
        function () {
          clearTimeout(to);
          reject(new Error("skmk: image error"));
        },
        { once: true },
      );
    });
  }

  function clamp01(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
  }
  function easeOutCubic(n) {
    return 1 - Math.pow(1 - n, 3);
  }
  function easeInOutCubic(n) {
    return n < 0.5 ? 4 * n * n * n : 1 - Math.pow(-2 * n + 2, 3) / 2;
  }

  /* ---------- intro ---------- */

  function runIntro() {
    if (finished) return;

    var ctx = canvas.getContext("2d");
    if (!ctx) {
      finishToEndState();
      return;
    }

    var isMobile = window.matchMedia("(max-width: 749px)").matches;

    var natW = sourceImg.naturalWidth;
    var natH = sourceImg.naturalHeight;
    if (!natW || !natH) {
      finishToEndState();
      return;
    }

    // Sample the logo from an offscreen canvas at a capped resolution.
    var sampleW = Math.min(natW, 480);
    var sampleH = Math.max(1, Math.round(sampleW * (natH / natW)));

    var off = document.createElement("canvas");
    off.width = sampleW;
    off.height = sampleH;
    var offCtx = off.getContext("2d", { willReadFrequently: true });
    offCtx.drawImage(sourceImg, 0, 0, sampleW, sampleH);

    var pixels;
    try {
      pixels = offCtx.getImageData(0, 0, sampleW, sampleH).data;
    } catch (e) {
      finishToEndState();
      return;
    }

    var ALPHA = 128;
    var MAX_PARTICLES = isMobile ? 2200 : 6000;

    var step = isMobile ? 5 : 3;
    var particles = sample(step);
    while (particles.length > MAX_PARTICLES) {
      step += 1;
      particles = sample(step);
    }
    if (!particles.length) {
      finishToEndState();
      return;
    }

    function sample(s) {
      var list = [];
      for (var y = 0; y < sampleH; y += s) {
        for (var x = 0; x < sampleW; x += s) {
          var i = (y * sampleW + x) * 4;
          if (pixels[i + 3] > ALPHA) {
            var angle = Math.random() * Math.PI * 2;
            var mag =
              (isMobile ? 30 : 50) + Math.random() * (isMobile ? 130 : 210);
            list.push({
              u: x / sampleW,
              v: y / sampleH,
              rgb:
                "rgb(" +
                pixels[i] +
                "," +
                pixels[i + 1] +
                "," +
                pixels[i + 2] +
                ")",
              a: pixels[i + 3] / 255,
              ox: Math.cos(angle) * mag,
              oy: Math.sin(angle) * mag - Math.random() * 40,
              delay: Math.random() * 0.3,
              phase: Math.random() * Math.PI * 2,
              freq: 1.4 + Math.random() * 2.6,
              swirl: (Math.random() - 0.5) * (isMobile ? 36 : 64),
            });
          }
        }
      }
      return list;
    }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var vw, vh, startSize, endSize;

    function sizeCanvas() {
      vw = window.innerWidth;
      vh = window.innerHeight;
      canvas.width = Math.floor(vw * dpr);
      canvas.height = Math.floor(vh * dpr);
      canvas.style.width = vw + "px";
      canvas.style.height = vh + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function computeGeometry() {
      var big = sourceImg.getBoundingClientRect();
      var small = targetLogo.getBoundingClientRect();
      // Fall back to the natural aspect ratio if the header logo has not laid out yet.
      var smallW = small.width;
      var smallH = small.height;
      if (smallW < 1 && smallH > 0) smallW = smallH * (natW / natH);
      for (var p = 0; p < particles.length; p++) {
        var pt = particles[p];
        pt.sx = big.left + pt.u * big.width;
        pt.sy = big.top + pt.v * big.height;
        pt.scx = pt.sx + pt.ox;
        pt.scy = pt.sy + pt.oy;
        pt.ex = small.left + pt.u * smallW;
        pt.ey = small.top + pt.v * smallH;
      }
      startSize = Math.max(1.4, (big.width / sampleW) * step);
      endSize = Math.max(0.6, (smallW / sampleW) * step);
    }

    sizeCanvas();
    computeGeometry();

    var resizeTimer;
    window.addEventListener("resize", function () {
      if (finished) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (finished) return;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        sizeCanvas();
        computeGeometry();
      }, 150);
    });

    // Animation phase boundaries (fractions of DURATION).
    var HOLD = 0.2; // assembled big logo
    var SCATTER = 0.58; // disintegrate finished
    var SETTLE = 0.9; // reassembled, canvas begins fading

    var startTime = null;

    function frame(now) {
      if (finished) return;
      if (startTime === null) {
        startTime = now;
        // Hand off from the real <img> to the particle field invisibly.
        sourceImg.style.visibility = "hidden";
      }

      var t = clamp01((now - startTime) / DURATION);
      ctx.clearRect(0, 0, vw, vh);

      // Turbulence envelope: 0 at hold, peaks mid-flight, 0 by reassembly.
      var env =
        t > HOLD && t < SETTLE
          ? Math.sin(((t - HOLD) / (SETTLE - HOLD)) * Math.PI)
          : 0;
      var seconds = (t * DURATION) / 1000;

      for (var p = 0; p < particles.length; p++) {
        var pt = particles[p];
        var x, y, size;

        if (t <= HOLD) {
          x = pt.sx;
          y = pt.sy;
          size = startSize;
        } else if (t <= SCATTER) {
          var lb = (t - HOLD) / (SCATTER - HOLD);
          var e = easeOutCubic(clamp01((lb - pt.delay) / (1 - pt.delay)));
          x = pt.sx + (pt.scx - pt.sx) * e;
          y = pt.sy + (pt.scy - pt.sy) * e;
          size = startSize;
        } else {
          var lc = easeInOutCubic((t - SCATTER) / (1 - SCATTER));
          x = pt.scx + (pt.ex - pt.scx) * lc;
          y = pt.scy + (pt.ey - pt.scy) * lc;
          size = startSize + (endSize - startSize) * lc;
        }

        if (env > 0) {
          x += Math.sin(seconds * pt.freq + pt.phase) * pt.swirl * env;
          y += Math.cos(seconds * pt.freq + pt.phase) * pt.swirl * env * 0.65;
        }

        ctx.globalAlpha = pt.a;
        ctx.fillStyle = pt.rgb;
        var half = size / 2;
        ctx.fillRect(x - half, y - half, size, size);
      }

      // Fade the white overlay out as the logo disintegrates.
      if (t <= HOLD) {
        intro.style.opacity = "1";
      } else if (t < SCATTER) {
        intro.style.opacity = String(1 - (t - HOLD) / (SCATTER - HOLD));
      } else {
        intro.style.opacity = "0";
      }

      // Reveal the real header logo, then cross-fade the canvas away.
      // if (t >= SCATTER) targetLogo.classList.add('is-visible');
      if (t > SETTLE) {
        canvas.style.opacity = String(1 - (t - SETTLE) / (1 - SETTLE));
      }

      if (t < 1) {
        rafId = requestAnimationFrame(frame);
      } else {
        finishToEndState();
      }
    }

    rafId = requestAnimationFrame(frame);
  }
})();
